import { createListApiSchema } from '../General/schemas';
import { roleSchema } from '../Role/schemas';
import { typeSchema } from '../Type/schemas';
import { userSchema } from '../User/schemas';
import { GROUP_CONTACT_TYPES } from './types';
import z from 'zod';

export const groupDataSchema = z
	.object({
		// most data is not up-to-date in the group data, as info from company-API is moved to companyData
		aliasses: z.array(z.string()).optional(),
		companyId: z.string().optional(),
		createdAt: z.coerce.date().optional(),
		dateOfEstablishment: z.coerce.date().optional(),
		source: z.string().optional(),
		updatedAt: z.coerce.date().optional(),
		vcaType: z.string().optional(),
	})
	.catchall(z.unknown())
	.describe('GroupData');

export const companyDataSchema = z
	.object({
		addressLine1: z.string().optional(),
		addressLine2: z.string().optional(),
		aliasses: z.array(z.string()).optional(),
		companyId: z.string().optional(),
		country: z.string().optional(),
		createdAt: z.coerce.date().optional(),
		dateOfEstablishment: z.coerce.date().optional(),
		naceCodes: z.array(z.number()).optional(),
		name: z.string(),
		nationalNumber: z.string().optional(),
		place: z.string().optional(),
		postalCode: z.string().optional(),
		source: z.string().optional(),
		updatedAt: z.coerce.date(),
		vatNumber: z.string(),
		checks: z.record(z.any()).optional(),
	})
	.describe('CompanyData');

export const groupSchema = z
	.object({
		id: z.string(),
		archived: z.boolean(),
		archivedAt: z.date().optional(),
		name: z.string(),
		description: z.string().optional(),
		typeId: z.string(),
		adminIds: z.array(z.string()),
		possibleRoleIds: z.array(z.string()),
		documents: z.array(z.any()),
		requirements: z.array(
			z.object({
				key: z.string(),
				name: z.string(),
				status: z.enum(['pending', 'inReview', 'accepted', 'expired', 'expiryWarning']),
				issues: z.array(z.string()).optional(),
			}),
		),
		status: z.enum(['pending', 'inReview', 'accepted', 'expired', 'expiryWarning']),
		externalId: z.string().optional(),
		groupData: z.lazy(() => groupDataSchema).optional(),
		companyData: z.lazy(() => companyDataSchema).optional(),
		keywords: z.string(),
		possibleRoles: z.array(z.lazy(() => roleSchema)).optional(),
		admins: z.array(z.lazy(() => userSchema)).optional(),
		type: z.lazy(() => typeSchema).optional(),
		automaticReviewReasons: z.array(z.string()).optional().nullable(),
		markedForReview: z.array(z.string()).optional().nullable(),
		uniqueId: z.string().optional(),
		isBlocked: z.boolean(),
		readOnly: z.boolean().optional(),
		contacts: z
			.array(
				z.object({
					id: z.string().uuid(),
					type: z.enum(GROUP_CONTACT_TYPES),
					name: z.string(),
					email: z.string().optional(),
					phone: z.string().optional(),
				}),
			)
			.optional(),
		legalForm: z.enum(['company', 'selfEmployed']).optional(),
	})
	.describe('Company');

export const groupListSchema = z.array(groupSchema).describe('Groups');
export const groupsApiResponseSchema = createListApiSchema(groupSchema).describe('Companies');
